import React from 'react';
import './sentry';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import Amplify from 'aws-amplify';
import { BrowserRouter } from 'react-router-dom';
import ImpersonateUpdatesLayer from 'components/Base/ImpersonateUpdatesLayer';
import { NotificationsRedirectLayer } from 'components/Shared/NotificationsRedirectLayer';
import { store } from 'redux/store';
import RoutesPage from 'routes';
import ThemeWrapper from 'theme/ThemeWrapper';
import ErrorFallback from 'components/Shared/ErrorFallback';
import amplifyConfig from 'aws-exports';

Amplify.configure(amplifyConfig);

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <BrowserRouter>
        <Provider store={store}>
          <NotificationsRedirectLayer>
            <ThemeWrapper>
              <ImpersonateUpdatesLayer>
                <RoutesPage />
              </ImpersonateUpdatesLayer>
            </ThemeWrapper>
          </NotificationsRedirectLayer>
        </Provider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;
